// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SiZX","title":"styles_title__1YPwR"};